import React, { useMemo, useState } from 'react';
import { ArrayUtils } from '@colonist/utils';
import { Dialog, Select, T, useTranslation } from '@colonist/ui';
import styles from './ReportPlayerDialog.module.scss';
const NO_REASON_SELECTED = '';
/** Dialog letting a player pick a reason to report another player. */ export function ReportPlayerDialog({ open, onClose, playerName, reasons, onReport }) {
    const { t } = useTranslation();
    const [selectedReasonId, setSelectedReasonId] = useState(NO_REASON_SELECTED);
    const randomizedReasonsToPreventOrderingBias = useMemo(()=>ArrayUtils.shuffle(reasons), [
        reasons
    ]);
    const hasNoReasonSelected = selectedReasonId == NO_REASON_SELECTED;
    const handleClose = ()=>{
        setSelectedReasonId(NO_REASON_SELECTED);
        onClose();
    };
    const handleConfirm = ()=>{
        if (hasNoReasonSelected) return;
        onReport(selectedReasonId);
        handleClose();
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: handleClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.reportPopup.title',
            options: {
                playerUsername: playerName
            }
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.body
    }, /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.reportPopup.body',
            options: {
                playerUsername: playerName
            }
        }
    })), /*#__PURE__*/ React.createElement(Select, {
        value: selectedReasonId,
        onSelect: setSelectedReasonId
    }, [
        /*#__PURE__*/ React.createElement("option", {
            key: NO_REASON_SELECTED,
            value: NO_REASON_SELECTED
        }, t('strings:popups.reportPopup.reasons.selection')),
        ...randomizedReasonsToPreventOrderingBias.map((reason)=>/*#__PURE__*/ React.createElement("option", {
                key: reason.id,
                value: reason.id
            }, t(reason.label)))
    ]))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.CancelButton, {
        onClick: handleClose
    }), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: handleConfirm,
        disabled: hasNoReasonSelected
    })));
}
